// components
import { Navbar, Footer } from "@/components";

// sections
import Faq from "../../faq";
import OurPrograms from "../../our-programs";
import { Link } from "react-router-dom";
import CarouselFeatures from "@/app/carousel-features";
import { CalendlyWidget } from "@/components/widget";

const CyclingTrainings = () => {
  return (
    <section className="mb-20 container text-center md:text-left mt-6 md:mt-10 mx-auto px-6">
      <h1 className="mb-8 text-center text-4xl font-bold">Cycling Trainings</h1>

      <p className="mb-6">
        In today's fast-paced world, where health and fitness are increasingly
        becoming priorities, the choice of how we train and who guides our
        fitness journey is more important than ever. Many turn to digital
        solutions like TrainingPeaks for guidance. While these platforms offer
        convenience and a general framework for fitness, they lack the personal
        touch and adaptability that come with a personal trainer. Here's why
        having individual training plans much more beneficial than general plans
        from TrainingPeaks.
      </p>

      <img
        width={500}
        height={600}
        src={`${import.meta.env.VITE_BASE_URL ?? ""}/image/cycling_1.webp`}
        className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
        alt=""
      />

      <h2 className="mb-4 text-3xl font-bold">
        Personalization to Your Unique Needs
      </h2>

      <p className="mb-6">
        First and foremost, a personal trainer offers a level of personalization
        that a general plan simply cannot. Every individual's body is unique,
        with its strengths, weaknesses, and specific health concerns. A personal
        trainer will conduct a thorough assessment of your physical condition,
        consider your fitness goals, and create a customized plan tailored just
        for you. This personalization is crucial for effectiveness and
        efficiency in training. For instance, if you're recovering from an
        injury, a general plan might not accommodate your rehabilitation needs,
        whereas a personal trainer can adjust exercises and intensity to align
        with your recovery.
      </p>

      <p
        style={{ borderColor: "green" }}
        className="mb-6 rounded border-l-4 border-neutral-800 bg-green p-2 dark:border-neutral-200 dark:bg-neutral-700"
      >
        <strong>Note:</strong> At NRC Team we are offering an individual and
        flexible options, which will be suitable for everyone. Find more about
        what we{" "}
        <Link
          style={{ textDecoration: "underline", fontWeight: "bold" }}
          to="/coaching"
        >
          offer
        </Link>{" "}
        and start your journey today.
      </p>

      <p className="mb-6">
        Fitness is not a static journey. As you progress, your abilities, needs,
        and goals evolve. A personal trainer can dynamically adapt your training
        program in real time. They can increase the intensity when you're ready
        for a challenge or dial it back when you need more recovery time. This
        kind of dynamic adaptation is something that a generic training plan
        cannot offer. Furthermore, personal trainers provide immediate feedback
        on your technique and form during workouts, helping you perform
        exercises correctly and efficiently, reducing the risk of injury.
      </p>
      <p className="mb-6">
        Another critical advantage of a personal trainer is the accountability
        they provide. It's easy to skip a workout or slack off when you're
        following a digital plan alone. However, having a scheduled session with
        a personal trainer creates a commitment that is harder to break.
        Personal trainers also excel in motivating their clients. They
        understand how to push you out of your comfort zone while ensuring you
        don't feel overwhelmed. This motivational aspect is often what keeps
        people consistent in their fitness routines, leading to better results.
      </p>

      <img
        width={500}
        height={600}
        src={`${import.meta.env.VITE_BASE_URL ?? ""}/image/cycling_2.webp`}
        className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
        alt=""
      />

      <h2 className="mb-4 text-3xl font-bold">Expertise and Experience</h2>

      <p className="mb-6">
        A personal trainer brings a wealth of knowledge and experience to your
        fitness journey. They are well-versed in the science of exercise and can
        offer insights that a digital plan cannot. This expertise is invaluable,
        especially when it comes to understanding the nuances of different
        exercises, how they benefit your body, and how to avoid common mistakes.
        Additionally, personal trainers often stay updated with the latest
        fitness trends and research, ensuring that your training regimen is not
        just personalized but also cutting-edge.
      </p>
      <p className="mb-6">
        Personal trainers usually adopt a holistic approach to fitness. They
        understand that exercise is just one component of a healthy lifestyle.
        Many trainers provide guidance on nutrition, sleep, stress management,
        and other lifestyle factors that can impact your fitness journey. This
        comprehensive approach ensures that you're not just working out
        efficiently but also making healthier choices in other areas of your
        life, leading to overall well-being.
      </p>
      <p className="mb-6">
        The journey to fitness is as much mental as it is physical. A personal
        trainer often becomes a coach, mentor, and confidant. They understand
        the emotional challenges that come with pushing your body to new limits.
        They can provide support, encouragement, and sometimes a listening ear,
        which can be crucial in moments of frustration or when you're feeling
        demotivated.
      </p>

      <img
        width={500}
        height={600}
        src={`${import.meta.env.VITE_BASE_URL ?? ""}/image/cycling_3.png`}
        className="mb-6 w-full rounded-lg shadow-lg dark:shadow-black/20"
        alt=""
      />

      <h2 className="mb-4 text-3xl font-bold">Customized Progress Tracking</h2>

      <p className="mb-6">
        While platforms like TrainingPeaks offer progress tracking, a personal
        trainer can provide a more nuanced analysis of your progress. They can
        help you understand not just what progress you’ve made, but also how and
        why. This deeper insight into your performance can be instrumental in
        sustaining motivation and setting realistic future goals.
      </p>
      <p className="mb-6">
        Personal trainers offer flexibility that fits your schedule and
        lifestyle. Unlike a fixed digital plan, training sessions with a
        personal trainer can be scheduled at your convenience. This flexibility
        ensures that your fitness routine integrates seamlessly into your life,
        making it more sustainable in the long run.
      </p>
      <p className="mb-6">
        Lastly, the relationship you build with a personal trainer can be a
        source of strength and inspiration. This relationship is based on trust,
        mutual respect, and a shared commitment to your fitness goals. A good
        personal trainer celebrates your victories, helps you learn from
        setbacks, and remains a constant in your journey towards a healthier,
        fitter you.
      </p>

      {/* <ul className="mb-6 list-inside list-disc">
          <li>Lorem</li>
          <li>Ipsum</li>
          <li>Dolor</li>
          <li>Sit</li>
          <li>Amet</li>
        </ul> */}

      <p>
        In conclusion, while digital training platforms like TrainingPeaks
        provide a good starting point, the benefits of having a personal trainer
        are unparalleled. Personal trainers offer a customized, adaptive, and
        holistic approach to fitness, providing not just physical training but
        also emotional support, motivation, and expert guidance. In a journey as
        personal and challenging as fitness, having a personal trainer by your
        side can make all the difference in achieving your goals and sustaining
        a healthy lifestyle.
      </p>
    </section>
  );
};

export default function CyclingTrainingsPage() {
  return (
    <>
      <Navbar />
      <CyclingTrainings />
      <OurPrograms />
      <CarouselFeatures />
      <CalendlyWidget />
      <Faq />
      <Footer />
    </>
  );
}
